<template>
  <div id="main">
    <canvas-glass-card title="筛选条件" variant="light" :hoverable="false" class="filter-card">
      <!-- 查询表单 -->
      <a-form :model="queryForm" label-align="left">
        <a-grid :cols="4" :colGap="26" :rowGap="0" :collapsed="collapsed" :collapsed-rows="1">
          <a-grid-item>
            <a-form-item label="物料编码" label-col-flex="60px">
              <a-input v-model="queryForm.materialCode" placeholder="请输入物料编码" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>

          <a-grid-item>
            <a-form-item label="物料名称" label-col-flex="60px">
              <a-input v-model="queryForm.materialName" placeholder="请输入物料名称" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="物料分类" label-col-flex="60px">
              <a-input-number v-model="queryForm.categoryId" placeholder="请输入物料分类" class="input" :hide-button="true" allow-clear/>
            </a-form-item>
            
          </a-grid-item>
          <a-grid-item suffix="suffix">
            <a-row :gutter="12">
              <a-col flex="75px">
                <a-button type="primary" @click="handleQuery" :loading="loading">
                  <template #icon>
                    <icon-search style="stroke: #fff"/>
                  </template>
                  搜索
                </a-button>
              </a-col>
              <a-col flex="65px">
                <a-button type="primary" status="warning" @click="handleReset">重置</a-button>
              </a-col>
              <a-col flex="65px">
                <a-button type="text " @click="()=>{collapsed = !collapsed}">
                  <template #icon>
                    <icon-down v-if="collapsed"/>
                    <icon-up v-else/>
                  </template>
                  {{ collapsed ? '展开' : '收起' }}
                </a-button>
              </a-col>
            </a-row>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="计量单位" label-col-flex="60px">
              <a-input v-model="queryForm.unit" placeholder="请选择计量单位" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>
        </a-grid>
      </a-form>
    </canvas-glass-card>
    <a-space />
    <canvas-glass-card title="物料信息列表" variant="light" :hoverable="false" class="table-card">

      <!-- 数据表格 -->
      <div class="table-wrapper">
        <a-table
            row-key="id"
            :columns="columns"
            :data="pagination.records"
            :pagination="false"
            :loading="loading"
            column-resizable
            stripe
            :bordered="{cell:true}"
        >
          <template #createTime="{ record }">
            {{ formatDate(record.createTime) }}
          </template>

          <template #updateTime="{ record }">
            {{ formatDate(record.updateTime) }}
          </template>
        </a-table>
      </div>

      <!-- 分页组件 -->
      <div class="pagination">
        <a-pagination
            style="justify-content: end;margin: 10px;"
            :total="pagination.total"
            v-model:current="pagination.current"
            v-model:page-size="pagination.size"
            show-total
            show-jumper
            show-page-size
            @change="handlePageChange"
            @page-size-change="handlePageSizeChange"
        />
      </div>
    </canvas-glass-card>
  </div>
</template>

<script>
import {getBaseDataMaterialInfoList} from "@/apis/base-data-api";
import {Message} from "@arco-design/web-vue";
import CanvasGlassCard from "@/components/CanvasGlassCard.vue";
import {IconSearch} from "@arco-design/web-vue/es/icon";
import {getDictDataOfMaterialType} from "@/apis/system-data";
import {timestampNumber2dateString} from "@/utils/date-util";

export default {
  name: 'MaterialInfo',
  components: {IconSearch, CanvasGlassCard},
  data() {
    return {
      // 条件查询表单数据
      queryForm: {
        // 物料编码
        materialCode: '',
        // 物料名称
        materialName: '',
        // 物料分类
        categoryId: '',
        // 计量单位
        unit: '',
      },
      // 条件查询表单折叠
      collapsed: true,
      // 数据表格列配置
      columns: [
        // {
        //   title: 'ID',
        //   dataIndex: 'id',
        //   width: 80,
        //   fixed: 'left'
        // },
        {
          title: '排序序号',
          dataIndex: 'sortOrder',
          width: 120,
          sortable: {
            sortDirections: ['ascend', 'descend']
          },
        },
        {
          title: '物料编码',
          dataIndex: 'materialCode',
          width: 120,
          ellipsis: true,
          tooltip: true
        },
        {
          title: '物料名称',
          dataIndex: 'materialName',
          width: 150,
          ellipsis: true,
          tooltip: true
        },
        {
          title: '物料分类',
          dataIndex: 'categoryId',
          width: 100,
          ellipsis: true,
          tooltip: true
        },
        {
          title: '计量单位',
          dataIndex: 'unit',
          ellipsis: true,
          tooltip: true,
          width: 100
        },
        {
          title: '使用方法',
          dataIndex: 'usageMethod',
          ellipsis: true,
          tooltip: true,
          width: 160
        },
        {
          title: '物料描述',
          dataIndex: 'materialDescription',
          ellipsis: true,
          tooltip: true,
          width: 200
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          slotName: 'createTime',
          width: 160,
          ellipsis: true,
          tooltip: true
        },
        {
          title: '最后修改时间',
          dataIndex: 'updateTime',
          slotName: 'updateTime',
          width: 160,
          ellipsis: true,
          tooltip: true
        },
      ],
      // 分页信息
      pagination: {
        records: [],
        current: 1,
        size: 10,
        pages: 0,
        total: 0
      },
      // 加载状态
      loading: false

    }
  },
  mounted() {
    this.fetchTableData();
  },
  methods: {
    // 获取表格数据
    fetchTableData() {
      this.loading = true;
      getBaseDataMaterialInfoList({
        ...this.queryForm,
        current: this.pagination.current,
        size: this.pagination.size
      }).then(response => {
        // console.log(response)
        this.loading = false;
        if (response.code === 0) {
          this.pagination = response.data;
        } else {
          Message.error(response.message);
        }
      }).catch(error => {
        Message.error(error.message)
      })

    },
    // 获取 物料分类 字典数据
    fetchMaterialTypeDictData() {
      getDictDataOfMaterialType()
          .then(response => {
            if (response.code === 0) {
            } else {
              Message.error(response.message);
            }
          })
          .catch(error => {
            Message.error(error);
          })
    },
    // 处理查询
    handleQuery() {
      this.pagination.current = 1;
      this.fetchTableData();
    },

    // 处理重置
    handleReset() {
      this.queryForm = {
        materialCode: '',
        materialName: '',
        categoryId: '',
        unit: '',
      };
      this.handleQuery();
    },

    // 处理页码变化
    handlePageChange(page) {
      console.log(page)
      this.fetchTableData();
    },

    // 处理每页数量变化
    handlePageSizeChange(pageSize) {
      this.pagination.pageSize = pageSize;
      this.pagination.current = 1;
      this.fetchTableData();
    },

    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '—';
      // return dateString.substring(0, 16).replace('T', ' ');
      return timestampNumber2dateString(dateString)
    },

  },
}
</script>

<style scoped>
.input {
  border: var(--color-text-4) solid 1px;
}
</style>